import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Helpers } from '../../../../../helpers';
import { BaseComponent } from '../../base.component';
import { Reservation } from '../../../../../models/reservation';
import { DataService } from '../../../../../_services/data.service';
import { ReservationService } from '../../../../../services/reservation.service';
import {
    SelectService,
    SelectEvent
} from '../../../../../_services/select.service';
import { ReservationSearchModel } from '../../../../../models/reservationSearchModel';
import { LoadingService } from '../../../../../_services/loading.service';
import { DatepickerService } from '../../../../../_services/datepicker.service';
import { zip } from 'rxjs/operators';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    encapsulation: ViewEncapsulation.None
})
export class DashboardComponent extends BaseComponent implements OnInit {
    model: Reservation = new Reservation();
    reservationSearchModel: ReservationSearchModel = new ReservationSearchModel();
    adUnits: any[] = [];
    tomorrowDate: Date[] = [];
    reservationDetails: any[] = [];
    updateVisible: boolean = false;
    selectedReservationId: string;
    tomorrowReservationSearchKey: string = '';
    filteredReservationDetails: any[] = [];
    user: any;
    selectedDates: any[] = [];

    constructor(
        private datepickerService: DatepickerService,
        private reservationService: ReservationService,
        private dataService: DataService,
        private loading: LoadingService
    ) {
        super();
        this.model.publisherId = this.dataService.publisherId;
    }
    ngOnInit() {

        var dashboardDatePicker = this.datepickerService.init('dashboardDatePicker', {
            format: 'dd/mm/yyyy'
        });
        this.user = this.dataService.getUser();
        this.tomorrowReservationSearchKey = "";
        this.setDefaultDates();
        this.searchReservation();
    }
    searchReservation() {
        this.loading.show();
        this.reservationService
            .reservationDetailSearch({
                dates: this.selectedDates,
                adUnitIds: []
            })
            .subscribe(res => {
                this.filterDashboardSearchData(res.data);
                this.loadFilteredReservationDetails();
                this.loading.hide();
            });
    }
    setDefaultDates() {
        var date = new Date();
        date.setDate(date.getDate());
        var tomorrow = Helpers.getUTCDate(date);
        this.selectedDates.push(tomorrow);
    }
    tomorrowReservationSearch(event) {
        this.tomorrowReservationSearchKey = event.target.value.toLowerCase();
        this.loadFilteredReservationDetails();
    }

    loadFilteredReservationDetails() {
        var self = this;
        this.filteredReservationDetails = this.reservationDetails.filter(function(
            a
        ) {
            return a.reservation.createdByUserName
                .toLowerCase()
                .includes(self.tomorrowReservationSearchKey.toLowerCase()) || a.reservation.updatedByUserName
                    .toLowerCase()
                    .includes(self.tomorrowReservationSearchKey.toLowerCase());
        });
    }

    searchReservationDate() {
        this.selectedDates = this.datepickerService.getDates('dashboardDatePicker');
        this.selectedDates = this.selectedDates.sort((a, b) => a - b);
        this.searchReservation();
    }


    filterDashboardSearchData(data) {
        var self = this;
        var reservationData = data.reduce((acc, cur) => {
            for (const reservationDetailDate of cur.reservationDetailDates) {

                self.selectedDates.forEach(selectedDate => {
                    if (selectedDate.toDateString() == new Date(reservationDetailDate.date).toDateString()) {
                        acc.push({ ...cur, date: selectedDate })
                    }
                });
            }
            return acc
        }, []);

        this.reservationDetails = reservationData.sort((a, b) => a.date - b.date);

    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/publisher/dashboard/dashboard.component.ts